import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoPoliticaCalidad from "../legal/InfoPoliticaCalidad";
const Footer = lazy(() => import('../footer/Footer'));
function PoliticaCalidad() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai nos preocupamos por tu seguridad."
        />
        <meta name="keywords" content="politica, calidad, Hyundai" />
        <title>Politica de Calidad | Hyundai</title>
      </Helmet>
      <Menu />
      <InfoPoliticaCalidad />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default PoliticaCalidad;